import React from 'react';
import { LayoutDashboard, Users, MessageSquare, BarChart3, LogOut } from 'lucide-react';
import { NavLink, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/vvslogo.jpeg';
import { useApiHandler } from '../../utils/apiHandler';
import { setRegToken, setEmployeydata } from '../../Redux/Action/Authaction';
import {  useDispatch } from 'react-redux';

const Sidebar = () => {
  const navigate = useNavigate(); // For programmatic navigation after logout
  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard' },
    { icon: Users, label: 'Task', path: '/task' },
    { icon: BarChart3, label: 'Documents', path: '/documents' },
    // { icon: MessageSquare, label: 'Chat', path: '/chat' },
  ];
  const apiHandler = useApiHandler();
  const dispatch = useDispatch();


  // Logout function to call the logout API and clear session
  const handleLogout = async () => {
    try {
      const response = await apiHandler.post('/employee/logout'); // Replace with your actual API endpoint
      if (response.data.success) {
        dispatch(setRegToken(""));
        dispatch(setEmployeydata(""));
        navigate("/");
      }

    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <div className="w-64 bg-white border-r border-gray-200 flex flex-col">
      <div className="p-6 m-auto">
        <img src={Logo} className="h-10 w-10" alt="Logo" />
      </div>

      <nav className="flex-1 px-4">
        <ul className="space-y-1">
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 text-sm rounded-lg ${isActive
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-700 hover:bg-gray-100'
                  }`
                }
              >
                <item.icon className="h-5 w-5 mr-3" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="p-4 border-t border-gray-200">
        <button
          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 rounded-lg w-full"
          onClick={handleLogout} // Call the logout function
        >
          <LogOut className="h-5 w-5 mr-3" />
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
